import React, {useEffect, useRef, useState} from 'react'
import styles from './FJPanelAnimation.module.less'
import classNames from 'classnames'

function FJPanelAnimation(props) {

  const {style, active, className, direction, render} = props;

  // show、shown、hide、hidden
  const [shownStatus, updateShownStatus] = useState('hidden');
  const timerRef = useRef(null);
  const hasInit = useRef(false);
  const classBtn = classNames(
    styles.content,
    className,
    {[styles.active]: active},
    {[styles.up]: (direction === 1 && active)},
    {[styles.down]: (direction === 0 && active)});

  const updateStatusWithTimer = (status) => {

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    return setTimeout(() => {
      if (!hasInit.current && status === 'shown') hasInit.current = true;
      updateShownStatus(status);
    }, 350);
  };

  useEffect(() => {
    if (active) {
      updateShownStatus('show');
      timerRef.current = updateStatusWithTimer('shown');
    } else {
      updateShownStatus('hide');
      timerRef.current = updateStatusWithTimer('hidden');
    }
  }, [active]);

  let containerStyle = {...style};
  if (shownStatus === 'hidden') {
    containerStyle.zIndex = -1;
  } else {
    containerStyle.zIndex = 22;
  }

  return (
    <div style={containerStyle} className={classBtn}>
      {render(hasInit.current, shownStatus)}
    </div>
  );
}

export default FJPanelAnimation;
